import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=07586a12&scoped=true&"
import script from "./FormElement.vue?vue&type=script&lang=ts&"
export * from "./FormElement.vue?vue&type=script&lang=ts&"
import style0 from "./FormElement.vue?vue&type=style&index=0&id=07586a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07586a12",
  null
  
)

export default component.exports